var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vector3, Quaternion, Matrix4 } from "flavr-math";
export class ModelScriptBase {
    constructor(uid) {
        this.uid = uid;
        this.persistentVariable = (_variableName) => { };
        this.getRelativeId = () => { return ""; };
        this.getName = () => { return ""; };
        this.destroyMe = (_force) => { return false; };
        /// Find script ///
        this.getScriptByClassName = (_className) => { return undefined; };
        this.findScriptsByClassInChildren = (_className) => { return []; };
        /// Other script functions ///
        this.activateModelScripts = (_modelUID, _scriptFileIds) => { };
        /// Emit function ///
        this.emit = (_funcName, ..._params) => { return false; };
        this.emitParent = (_funcName, ..._params) => { return false; };
        this.emitAll = (_funcName, ..._params) => { return false; };
        this.emitTo = (_uid, _funcName, ..._params) => { return false; };
        // =========================================================================
        // Common model methods
        // =========================================================================
        /// Find model ///
        this.getModel = () => { return undefined; };
        this.getModelByUid = (_uid) => { return undefined; };
        this.getParentModel = () => { return undefined; };
        this.getChildModelByRelativeId = (_relativeId) => { return undefined; };
        this.findModelsByName = (_nameOrPart, _options) => { return []; };
        this.findModelsByClass = (_className) => { return []; };
        this.findModelsByFacetType = (_facetType) => { return []; };
        /// Facet ///
        this.updateFacet = (_facet, _force) => { return false; };
        this.removeFacet = (_facetType) => { return false; };
        this.getFacet = (_facetType) => { return undefined; };
        this.hasFacet = (_facetType) => { return false; };
        this.setFacetVisibility = (_facetType, _visible) => { };
        /// UI3D ///
        this.getUiElement = (_selector) => { return undefined; };
        /// Material ///
        this.setMaterialColor = (_materialColor, _materialName) => { };
        this.setMaterialParameter = (_key, _value, _expectedType, _materialIndex) => { return false; };
        this.getMaterialParameter = (_key, _expectedType, _materialIndex) => { return undefined; };
        /// Transform ///
        this.setPosition = (_position) => { };
        this.setOrientation = (_orientation) => { };
        this.setScale = (_scale) => { };
        this.setTransform = (_position, _orientation, _scale) => { };
        this.setWorldPosition = (_worldPosition) => { };
        this.setWorldOrientation = (_worldOrientation) => { };
        this.setWorldScale = (_worldScale) => { };
        this.setWorldTransform = (_position, _orientation, _scale) => { };
        this.getPosition = () => { return new Vector3(); };
        this.getOrientation = () => { return new Quaternion(); };
        this.getScale = () => { return new Vector3(1, 1, 1); };
        this.getMatrix = () => { return new Matrix4(); };
        this.getWorldPosition = () => { return new Vector3(); };
        this.getWorldOrientation = () => { return new Quaternion(); };
        this.getWorldScale = () => { return new Vector3(1, 1, 1); };
        this.getWorldMatrix = () => { return new Matrix4(); };
        /// Messaging ///
        this.subscribeBusMessage = (_topic, _callback) => { return false; };
        this.unsubscribeBusMessage = (_topic) => { return false; };
        this.unsubscribeAllBusMessage = () => { };
        this.sendBusMessage = (_topic, _data) => { };
        this.enableGesture = (_type, _enable) => { };
        this.enableControllerAnnotation = (_enable) => { };
        this.setAllButtonsToOneButtonType = (_buttonType) => { };
        this.setControllerStrategyForHands = (_hands, _strategy) => { };
        /// Audio ///
        this.playSound = (_url, _params) => { return false; };
        this.broadcastSound = (_url, _params) => { return false; };
        this.localOnly = () => { };
        this.setNetworked = () => { return false; };
        this.takeOwnership = (_destroyWhenOwnerDisconnect) => __awaiter(this, void 0, void 0, function* () { return false; });
        this.surrenderOwnership = () => { return false; };
        this.isHost = () => { return false; };
        this.isMine = () => { return false; };
        this.controlledByOthers = () => { return false; };
        this.hasNetworkOwner = () => { return false; };
        this.getNetworkOwner = () => { return undefined; };
        this.getNetworkCreator = () => { return undefined; };
        this.canPickup = (_controllerUid) => __awaiter(this, void 0, void 0, function* () { return false; });
        this.pickup = (_params) => __awaiter(this, void 0, void 0, function* () { return undefined; });
        this.drop = (_modelUID) => { return false; };
        /// Tooltip ///
        this.createToolTipModel = (_position, _normal, _scale, _capturedText, _color) => __awaiter(this, void 0, void 0, function* () { return undefined; });
        /// Drop file ///
        this.subscribeDropFile = (_callback) => { };
        this.unsubscribeDropFile = () => { };
        /// RPC ///
        this.rpc = (_funcName, ..._params) => { };
        this.rpcAndLocal = (_funcName, ..._params) => { };
        this.rpcOnlyHost = (_funcName, ..._params) => { };
        this.rpcOnlyHostAndLocal = (_funcName, ..._params) => { };
    }
}
